import React from "react";

/**
 *
 * @param heading - The heading to display. Defaults to "No results found."
 * @param caption - The caption to display below the heading. Defaults to "Please try adjusting your search."
 * @param children - Any additional React nodes to display below the caption.
 *
 * DEV NOTE: For similar styling without the caption div, use the NoResultsSingleLine component
 */
export function NoResultsFound({
  heading = "No results found.",
  caption = "Please try adjusting your search.",
  children,
}: React.PropsWithChildren<{ heading?: string; caption?: string }>) {
  return (
    <div className="margin--y--l">
      <h4 className="fontFamily--body">{heading}</h4>
      <div className="margin--top--xxs">
        {caption} {children}
      </div>
    </div>
  );
}
